<div *ngIf="!isMobileLayout">
    
    <span style="display: block; text-align: center; font-size: 23px;">
        <b style="color: brown;">Nexus</b>&nbsp;<b>Partner Network</b> _ <b style="color: orange;">Hyderabad</b> <b style="color: rgb(91, 182, 243);">(Telangana)</b>
        &nbsp; <img src="assets/img/hyderabad-charminar.png" style="width: 60px; height: auto;">
    </span>
    

    <div class="agent-grid">
    <div class="agent-card" *ngFor="let agent of agents">
      <div class="agent-container">
        <!-- Left Section: Photo extending out -->
        <div class="agent-photo-container">
          <img [src]="agent.image" alt="{{ agent.name }}" class="agent-photo" />
        </div>
  
        <!-- Right Section: Details -->
        <div class="agent-details-container">
          <div class="badges">
            <span *ngIf="agent.verified" class="verified-badge">✔ VERIFIED</span>
            <span *ngIf="agent.expert" class="expert-badge">Expert Pro Agent</span>
            <span *ngIf="agent.reraRegistered" class="rera-badge">✔ RERA REGISTERED</span>
          </div>
          <h3 class="agent-name">{{ agent.name }}</h3>
          <div class="agent-details">
            <span class="agent-rating">⭐ {{ agent.rating }}</span>
            <!-- <span class="agent-rating"><img src="assets/img/star.png" style="width: 14px; height: 16px;">{{ agent.rating }}</span>  -->
            <span class="agent-experience">{{ agent.experience }} Yrs</span>
          </div>
          <div class="agent-contact">
            <p>
                <img src="assets/img/cell-phone.png" style="width: 14px; height: auto;"> {{ agent.phone }}
            </p>
            <p>
                
                <img src="assets/img/gmail.png" style="width: 14px; height: auto;">  {{ agent.email }}
            </p>
          </div>
          
        </div>
      </div>
    </div>
  </div>
  </div>


  <div *ngIf="isMobileLayout">
  <span style="display: block; text-align: center; font-size: 23px; margin-top: 30px;">
    <b style="color: brown;">Nexus</b>&nbsp;<b>Partner Network</b> _ <br></span>
    <span style="display: block; text-align: center; font-size: 23px;">
    <b style="color: orange;">Hyderabad</b> <b style="color: rgb(91, 182, 243);">(Telangana)</b>
    &nbsp; <img src="assets/img/hyderabad-charminar.png" style="width: 40px; height: auto;">
    </span>
  <div class="agent-grid">
    <div class="agent-card" *ngFor="let agent of agents">
      <div class="agent-container">
        <!-- Left Section: Photo extending out -->
        <div class="agent-photo-container">
          <img [src]="agent.image" alt="{{ agent.name }}" class="agent-photo" />
        </div>
  
        <!-- Right Section: Details -->
        <div class="agent-details-container">
          <div class="badges">
            <span *ngIf="agent.verified" class="verified-badge">✔ VERIFIED</span>
            <span *ngIf="agent.expert" class="expert-badge">Expert Pro Agent</span>
            <span *ngIf="agent.reraRegistered" class="rera-badge">✔ RERA REGISTERED</span>
          </div>
          <h3 class="agent-name">{{ agent.name }}</h3>
          <div class="agent-details">
            <span class="agent-rating">⭐ {{ agent.rating }}</span>
            <span class="agent-experience">{{ agent.experience }} Yrs</span>
          </div>
          <div class="agent-contact">
            <p>
                <img src="assets/img/cell-phone.png" style="width: 14px; height: auto;"> {{ agent.phone }}
            </p>
            <p>
                
                <img src="assets/img/gmail.png" style="width: 14px; height: auto;">  {{ agent.email }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  
  